export interface IAppCategory {
  displayName: string;
  value: string;
}
